import React, {useEffect, useState} from "react";
import {useVersionContext} from "../../context/GlobalContext";

const BackOnTop = () => {
    const {getVersion} = useVersionContext();
    const [isShowBtn, setIsShowBtn] = useState(false);
    let backOnTopLabel = '';
    if (getVersion() ===  1) backOnTopLabel = "🔺맨 위로";
    if (getVersion() === 2) backOnTopLabel = "▲";

    useEffect(() => {
        const showHideBtn = () => {
            // 스크롤이 맨 위면 숨김, 300px 이상 내려가면 표시
            if (window.scrollY > 300) {
                setIsShowBtn(true);
            } else {
                setIsShowBtn(false);
            }
        };

        window.addEventListener("scroll", showHideBtn);

        return () => {
            window.removeEventListener("scroll", showHideBtn);
        };
    }, []);


    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
        {isShowBtn && (
            <button onClick={scrollToTop} className='custom-back-on-top'>
                {backOnTopLabel}
            </button>
        )}
        </>
    );
}

export default BackOnTop;